import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

// #endregion

const StoresLineChart = React.memo(({ data }) => {
  return (
    <div className="card rounded-4">
      <div className="card-body">
        <h6 className="mb-3">اتجاه تسجيل المتجر</h6>
        <LineChart
          style={{
            width: "100%",
            height: "100%",
            maxHeight: "40vh",
            aspectRatio: 1.618,
          }}
          responsive
          data={data}
          margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month"  />
          <YAxis width="auto" dataKey="count" />
          <Tooltip />
          <Legend />

          <Line
            type="monotone"
            dataKey="count"
            name="المتاجر النشطة"
            stroke="#FFCC03"
            strokeWidth={2}
          />
        </LineChart>
      </div>
    </div>
  );
});
export default StoresLineChart;
